const numberFormatter = new Intl.NumberFormat('es');

function format(value) {
  return `$${numberFormatter.format(value)}`;
}

export default {
  format,
};
